import { bundleChannel } from "../../business"

export const getRepairTimeDivision = () => bundleChannel().last(1, "SET_REPAIR_TIME_DIVISION").first()?.content ?? 1
